import { formatDayAndTime } from 'common/alchemyComponents/EmailSubscription/utils';
import { weekdayStringsSundayStart } from 'common/utils/date';
import capitalize from 'lodash/capitalize';

export const INTERVALS = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
];

export const DAYS_OF_WEEK = weekdayStringsSundayStart.map((dayOfWeek, dayIndex) => ({
  label: capitalize(dayOfWeek),
  value: dayIndex.toString(),
}));

export const HOURS_IN_DAY = Array.from({ length: 24 }).map((_, index) => {
  const hour = index % 12 === 0 ? 12 : index % 12;
  const meridian = index < 12 ? 'A.M.' : 'P.M.';
  return { label: `${hour}:00 ${meridian}`, value: index.toString() };
});

export const DEFAULT_SUBSCRIPTION = {
  id: null,
  interval: INTERVALS[1].value,
  dayOfWeek: DAYS_OF_WEEK[1].value,
  sendAt: HOURS_IN_DAY[11].value,
  sendEmailAt: formatDayAndTime({
    dayOfWeek: DAYS_OF_WEEK[1].value,
    sendAtTime: HOURS_IN_DAY[11].value,
  }),
};
